import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LightbulbIcon } from 'lucide-react';
import { SettingsPath } from './SettingsPath';
import type { CheckStep } from '../types/checks';
type CheckCardProps = {
  step: CheckStep;
  done: boolean;
  onToggle: (id: string) => void;
};
export function CheckCard({
  step,
  done,
  onToggle
}: CheckCardProps) {
  return <motion.article initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.4,
    ease: 'easeOut'
  }} className={`rounded-4xl border bg-paper p-6 transition-colors sm:p-8 ${done ? 'border-mint/40' : 'border-line'}`} data-id="element-11" data-mp="1g1ufv7lzg0v5">
      <div className="flex items-start gap-4" data-id="element-12" data-mp="1yr0q068pnk5c">
        <span className={`mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-bold transition-colors ${done ? 'bg-mint text-white' : 'bg-ink text-white'}`} aria-hidden="true" data-id="element-13" data-mp="1ysbts625orwg">
          {done ? <CheckIcon className="h-5 w-5" data-id="element-14" data-mp="2gmfjowv7au9l" /> : step.number}
        </span>
        <div className="min-w-0 flex-1" data-id="element-15" data-mp="2lj5zrk709pv0">
          <h3 className="text-xl font-bold tracking-tight text-ink sm:text-2xl" data-id="element-16" data-mp="2lk7m4kth1ys1">{step.title}</h3>

          <div className="mt-5" data-id="element-17" data-mp="2pk80k5gkm9z3">
            <SettingsPath path={step.path} data-id="element-18" data-mp="2ukdwhxtviimz" />
          </div>

          {step.toggles && <ul className="mt-5 space-y-2.5" data-id="element-19" data-mp="2zjqg89pg79lc">
              {step.toggles.map(toggle => <li key={toggle} className="flex items-start gap-2.5 text-[15px] text-ink-soft" data-id="element-20" data-mp="34itoe30q5vxj">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-mint" aria-hidden="true" data-id="element-21" data-mp="34gh0784dipc1" />
                  <span data-id="element-22" data-mp="39bwajq36a33p">{toggle}</span>
                </li>)}
            </ul>}

          {step.question && <p className="mt-5 text-[15px] leading-relaxed text-ink-soft" data-id="element-23" data-mp="3iazsuruimeh5">{step.question}</p>}

          <div className="mt-6 flex gap-3 rounded-2xl border border-line bg-mist/60 p-4" data-id="element-24" data-mp="3n8i0mewsqnnk">
            <LightbulbIcon className="mt-0.5 h-4 w-4 shrink-0 text-apple" aria-hidden="true" data-id="element-25" data-mp="1n6a6uvu2y33c" />
            <p className="text-sm leading-relaxed text-muted" data-id="element-26" data-mp="1i8gzw0kyd520">
              <span className="font-semibold text-ink" data-id="element-27" data-mp="1i64a518ydqee">{step.noteLabel} </span>
              {step.note}
            </p>
          </div>

          <button type="button" onClick={() => onToggle(step.id)} aria-pressed={done} className={`mt-6 inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-apple focus-visible:ring-offset-2 ${done ? 'bg-mint/10 text-mint hover:bg-mint/15' : 'bg-ink text-white hover:bg-ink-soft'}`} data-id="element-28" data-mp="1s5mvnm4ihk8k">
            <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-29" data-mp="lgwozuc8xjb0" />
            {done ? 'Verificado' : 'Marcar como hecho'}
          </button>
        </div>
      </div>
    </motion.article>;
}